import { render, staticRenderFns } from "./JobRating.vue?vue&type=template&id=08115176&"
import script from "./JobRating.vue?vue&type=script&lang=js&"
export * from "./JobRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports